var chunkToChildrenMap = {
	"6281": [
		8080,
		6422,
		1298,
		6515,
		7162
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));